import React, { Component } from 'react';
import { Heading, Text, CallToAction, Icon, Button } from '@movember/mo-gel';
import { withTheme } from 'styled-components';
import {
  StyledLowLevelGroupWrapper,
  StyledHeadingWrapper,
  StyledLowLevelInsightsContainer,
  StyledHeadingAndLinkWrapper,
  StyledHeading,
  StyledEditLinkText,
  StyledLinkWrapper,
  StyledHeadingTextWrapper,
  StyledChevron,
  StyledAdditionalsContainer,
  StyledOutcomeGroupWrapper,
  StyledOutcomeContainer
} from './LowLevelGroup.styled';
import { toPercentage } from '../../utils/numbers';
import { LifeChange, Treatment } from '../../utils/mapper';

class LowLevelGroupContainer extends Component {
  constructor(props) {
    super(props);

    this.state = { showAllLowLevel: false };
    this.initialDisplay = 4;
    this.initialDisplayBuffer = 6;
  }

  renderHeading = (categoryDomain) => {
    const { onBack } = this.props;

    return (
      <StyledHeadingWrapper>
        <StyledHeadingAndLinkWrapper>
          <StyledHeading level="h2" marginTop="1rem">
            {categoryDomain}
          </StyledHeading>
          <StyledLinkWrapper onClick={() => onBack(categoryDomain)}>
            <Icon>
              <StyledChevron />
            </Icon>
            <StyledEditLinkText level="small">Back to Life Changes</StyledEditLinkText>
          </StyledLinkWrapper>
        </StyledHeadingAndLinkWrapper>
        <StyledHeadingTextWrapper>
          <Text fontWeight="bold" align="left" tag="p" marginBottom="0">
            {`Men like you had a lot to say about ${categoryDomain}. Explore all of the insights below.`}
          </Text>
        </StyledHeadingTextWrapper>
      </StyledHeadingWrapper>
    );
  };

  onExploreArticles = () => {
    const { treatment, categoryDomain } = this.props;
    const trt = (Treatment[treatment] && `treatment:${Treatment[treatment]}`) || '';

    const hash = `#life_change:${LifeChange[categoryDomain]};${trt};`;
    window.location =
      (process.env.REACT_APP_BASE_URL && `${process.env.REACT_APP_BASE_URL}${hash}`) || `https://truenth.org${hash}`;
  };

  onShowMore = () => {
    this.setState({ showAllLowLevel: true });
  };

  render() {
    const { categoryDomain, outcomes, theme } = this.props;
    const { showAllLowLevel } = this.state;

    const category = outcomes.find((item) => item.categoryName === categoryDomain);
    let { lowLevelInsights } = category;
    const hasMore = lowLevelInsights.length > this.initialDisplayBuffer;
    if (!showAllLowLevel && hasMore) {
      lowLevelInsights = lowLevelInsights.slice(0, this.initialDisplay);
    }

    return (
      <StyledLowLevelGroupWrapper>
        {this.renderHeading(categoryDomain)}
        {category.lowLevelInsights.length > 0 && (
          <StyledLowLevelInsightsContainer>
            <StyledOutcomeGroupWrapper>
              {lowLevelInsights.map((insight, lowLevelIndex) => {
                return (
                  <StyledOutcomeContainer key={`lowLevelInsight-${lowLevelIndex}`} tag="li" borderCollapse columns={2}>
                    <Heading level="h2" color={theme.colors.actionPrimary300} marginBottom="0">
                      {`${toPercentage(insight.score).toLocaleString('en-GB', { maximumFractionDigits: 0 })}%`}
                    </Heading>
                    {insight.label && (
                      <Heading level="h6" color={theme.colors.actionPrimary300} marginBottom=".25rem">
                        {insight.label}
                      </Heading>
                    )}
                    <Text tag="p" marginBottom="0">
                      {insight.phrase.replace(
                        '{score}',
                        toPercentage(insight.score).toLocaleString('en-GB', { maximumFractionDigits: 0 })
                      )}
                    </Text>
                  </StyledOutcomeContainer>
                );
              })}
            </StyledOutcomeGroupWrapper>
            <StyledAdditionalsContainer>
              {!showAllLowLevel && hasMore && (
                <Button tertiary onClick={this.onShowMore}>
                  Show more +
                </Button>
              )}
            </StyledAdditionalsContainer>
            <StyledAdditionalsContainer>
              <CallToAction
                title={`If you’re having trouble with ${categoryDomain}, you’re not alone.`}
                titleLevel="h4"
                description="Use our True North articles for real guidance on the prostate cancer journey."
                buttonText="Explore articles"
                buttonWidth="100%"
                onButtonClick={this.onExploreArticles}
              />
            </StyledAdditionalsContainer>
          </StyledLowLevelInsightsContainer>
        )}
      </StyledLowLevelGroupWrapper>
    );
  }
}

const LowLevelGroupContainerWrapper = withTheme(LowLevelGroupContainer);
export { LowLevelGroupContainerWrapper as LowLevelGroup };
